import React from "react";
import PropTypes from "prop-types";
import fields from "../../json/SupplierFields.json";
import FormInput from "Common/Custom/FormInput";
import FormSubmitButton from "Common/Custom/FormSubmitButton";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import Switch from "Common/Custom/Switch";
import FormTextarea from "Common/Custom/FormTextarea";

const EditSupplierForm = ({
  values = {},
  errors = {},
  handleChange = () => { },
  handleSubmit = () => { },
  loading = false,
  title = "Update Supplier",
}) => {
  const { formdata } = fields;

  const renderField = (field) => {
    if (field.type === "switch") {
      return (
        <Switch
          key={field.name}
          field={field}
          values={values[field.name]}
          handleChange={handleChange}
          ValueOne="1"
          ValueTwo="0"
          LabelOne="Active"
          LabelTwo="Inactive"
        />
      );
    }

    if (field.type === "texttextarea") {
      return (
        <FormTextarea
          key={field.name}
          field={field}
          value={values[field.name] ?? ""}
          handleChange={handleChange}
          error={errors[field.name]}
          
        />
      );
    }

    return (
      <FormInput
        key={field.name}
        field={field}
        value={values[field.name] ?? ""}
        handleChange={handleChange}
        error={errors[field.name]}
      />
    );
  };

  return (
    <PageBody
      headerchildren={<HeadingOne>Edit Supplier</HeadingOne>}
      onSubmit={handleSubmit}
    >
      {formdata.map(renderField)}

      <FormSubmitButton
        label={title}
        loading={loading}
        colSize="col-12"
        align="end"
      />
    </PageBody>
  );
};

EditSupplierForm.propTypes = {
  values: PropTypes.object,
  errors: PropTypes.object,
  handleChange: PropTypes.func,
  handleSubmit: PropTypes.func,
  loading: PropTypes.bool,
  title: PropTypes.string,
};

export default EditSupplierForm;
